import styles from './source-whale-export-icons.module.css';

export const SourceWhaleContactsIcon = () => (
  <svg
    className={styles.themed}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M11.5 7C11.5 8.933 9.933 10.5 8 10.5C6.067 10.5 4.5 8.933 4.5 7C4.5 5.067 6.067 3.5 8 3.5C9.933 3.5 11.5 5.067 11.5 7Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 7.5C19.5 9.15685 18.1569 10.5 16.5 10.5C14.8431 10.5 13.5 9.15685 13.5 7.5C13.5 5.84315 14.8431 4.5 16.5 4.5C18.1569 4.5 19.5 5.84315 19.5 7.5Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 20.5H14.5C13.7873 9.83333 2.21275 9.83333 1.5 20.5Z"
      stroke="currentColor"
    />
    <path
      d="M16 19.5H22.5C22.0502 13.1194 16.9146 11.1008 13.5 13.4442"
      stroke="currentColor"
    />
  </svg>
);

export const SourceWhaleCampaignsIcon = () => (
  <svg
    className={styles.themed}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M18.498 14C20.1549 14 21.498 12.6569 21.498 11C21.498 9.34315 20.1549 8 18.498 8"
      stroke="currentColor"
    />
    <path
      d="M18.498 19.5V2.5L2.49805 7.28571V14.7143L18.498 19.5Z"
      stroke="currentColor"
    />
    <path
      d="M12.7988 18.6666L12.9654 18.1952L12.0225 17.862L11.8559 18.3334L12.3273 18.5L12.7988 18.6666ZM9.49805 20.5V20C8.11734 20 6.99805 18.8807 6.99805 17.5H6.49805H5.99805C5.99805 19.433 7.56505 21 9.49805 21V20.5ZM12.3273 18.5L11.8559 18.3334C11.5125 19.305 10.5858 20 9.49805 20V20.5V21C11.0227 21 12.3185 20.0253 12.7988 18.6666L12.3273 18.5ZM6.49805 17.5H6.99805V16H6.49805H5.99805V17.5H6.49805Z"
      fill="currentColor"
    />
    <path d="M6.50195 6.25V15.75" stroke="currentColor" />
  </svg>
);
